import { writable } from 'svelte/store';

export const user = writable({});
export const active_budget = writable(new Date().getFullYear());
export const sortParams = writable({});

export default user